import React from 'react';
import PropTypes from 'prop-types';
import { i18n } from '@lingui/core';

/**
 * SizeRangeHorizontalLegend - Легенда для горизонтально распределённых кругов разного размера
 *
 * Отображает круги разного размера, распределённые по ширине панели
 * Подписи расположены под кругами без выносок
 * Используется для отображения градуировки размеров (например, население)
 */
export const SizeRangeHorizontalLegend = ({ items, renderConfig }) => {
    const {
        description = null,
        minRadius = 8,
        maxRadius = 40,
    } = renderConfig;
    const radiuses = items.map((_, idx) => {
        const step = (maxRadius - minRadius) / (items.length - 1 || 1);
        return minRadius + (step * idx);
    });
    // Каждый контейнер занимает равную часть ширины
    const cellWidth = 100 / items.length;

    return (
        <div style={{ marginLeft: '10px', marginRight: '10px', marginBottom: '10px' }}>
            {/* Контейнер с элементами (круг + подпись вместе) */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'flex-end',
                    marginBottom: '12px',
                }}
            >
                {items.map((item, idx) => {
                    const radius = radiuses[idx];
                    const diameter = radius * 2;

                    return (
                        <div
                            key={item.id || item.label || idx}
                            style={{
                                width: `${cellWidth}%`,
                                display: 'flex',
                                flexDirection: 'column',
                                alignItems: 'center',
                                minWidth: '0',
                            }}
                        >
                            {/* Круг */}
                            <div
                                style={{
                                    width: `${diameter}px`,
                                    height: `${diameter}px`,
                                    borderRadius: '50%',
                                    backgroundColor: 'rgba(255, 255, 255, 0.3)',
                                    border: '1px solid rgba(255, 255, 255, 0.8)',
                                    boxSizing: 'border-box',
                                    transition: 'all 0.2s ease',
                                    flexShrink: 0,
                                }}
                            />
                            {/* Подпись */}
                            <div
                                style={{
                                    fontSize: '12px',
                                    color: 'rgba(220, 217, 217, 0.9)',
                                    marginTop: '6px',
                                    textAlign: 'center',
                                }}
                            >
                                {i18n._(item.label)}
                            </div>
                        </div>
                    );
                })}
            </div>

            {description && (
                <div style={{ padding: '10px' }}>
                    {description}
                </div>
            )}
        </div>
    );
};

SizeRangeHorizontalLegend.propTypes = {
    items: PropTypes.arrayOf(PropTypes.shape({
        id: PropTypes.string,
        label: PropTypes.object.isRequired,
        color: PropTypes.string,
    })).isRequired,
    renderConfig: PropTypes.object.isRequired,
};
